<ng-container *ngIf="!loading; else notLoaded">
  <ng-content></ng-content>
</ng-container>
<ng-template #notLoaded>
  <div class="d-flex justify-content-center">
    <mat-spinner color="warn" diameter="30"></mat-spinner>
  </div>
</ng-template>